"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Content;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _semanticUiReact = require("semantic-ui-react");

var _proptypes = require("../../services/proptypes");

var _ContentMarkup = _interopRequireDefault(require("./ContentMarkup"));

var _ContentImage = _interopRequireDefault(require("./ContentImage"));

function Content(_ref) {
  var children = _ref.children,
      gridProps = (0, _objectWithoutProperties2["default"])(_ref, ["children"]);

  if (!children || children.length === 0) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Grid, (0, _extends2["default"])({
    className: "content-section"
  }, gridProps), children);
}

;
Content.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].arrayOf(_propTypes["default"].node)]),
  columns: _propTypes["default"].string,
  textAlign: _proptypes.TextAlignPropType,
  verticalAlign: _proptypes.VerticalAlignPropType
};
Content.defaultProps = {
  children: null,
  columns: 'equal',
  textAlign: 'center',
  verticalAlign: 'middle'
};
Content.Markup = _ContentMarkup["default"];
Content.Image = _ContentImage["default"];